module.exports = __webpack_public_path__ + "static/media/family_menu.29b448cb.svg";